// extracted by mini-css-extract-plugin
module.exports = {"selectPage":"SelectPage_selectPage__YEgke"};